import axios from 'axios';
import getConfig from 'next/config';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { CONSTRUCTOR_SERVICE_URL } from 'search/enums/constants';
import { IConstructorFacetMultiple } from 'shared/types/ConstructorFacet';
import { ISubSection } from 'homepage/types/Feed';

const transformBrandList = (facets: Partial<IConstructorFacetMultiple>[]) => {
  const brandListObject = {};
  for (const facet of facets?.[0]?.options) {
    brandListObject[facet?.value] = { count: facet?.count, data: facet?.data };
  }
  return brandListObject;
};

export const setBrandsListsCountsOnSubsectionsClientSide = async (
  subsections: ISubSection[],
  commonHeaders,
  abortSignal,
) => {
  const {
    publicRuntimeConfig: { CONSTRUCTOR_API_KEY },
  }: { publicRuntimeConfig: { CONSTRUCTOR_API_KEY: string } } = getConfig();
  try {
    // the JS client library that the team opted to use doesn't support browsing facet options
    // so we need to make a clean call to constructor itself. If/when they do support it we can switch
    // TODO: Update to Constructor Javascript Client
    const sectionsWithBrandCounts = await axios
      .get(
        `${CONSTRUCTOR_SERVICE_URL}/browse/facet_options?facet_name=brand&key=${CONSTRUCTOR_API_KEY}`,
        {
          headers: commonHeaders,
          signal: abortSignal,
        },
      )
      .then((response) => {
        const brands = transformBrandList(response.data.response.facets);
        const newSections = [];

        // set count for each subsection brand
        for (const section of subsections) {
          const newSection = { ...section };
          const brandMetadata = brands[section?.searchConfig?.filterValue];
          newSection.count = brandMetadata?.count || 0;

          if (brandMetadata?.data?.location) {
            newSection.location = brandMetadata?.data?.location;
          }

          if (brandMetadata?.data?.year) {
            newSection.year = brandMetadata?.data?.year;
          }
          newSections.push(newSection);
        }
        return newSections;
      });

    return sectionsWithBrandCounts;
  } catch (error) {
    bugsnag(error, { context: 'Homepage Content Fetcher Brands List Count' });
  }

  return subsections;
};
